import React from 'react';
import { BookOpen, Loader2 } from 'lucide-react';
import MinimalistWorkCard from '@/components/obra/MinimalistWorkCard';
import { OBRAS_GENEROS } from '@/constants/obras-generos';

interface Obra {
    id: number;
    nome: string;
    imagem: string;
    favoritada?: boolean;
    total_capitulos?: number;
    capitulos_count?: number;
    formato?: { id: number; nome: string };
}

function formatoBadgeFromObra(obra: Obra): { label: string; color: string } | undefined {
    const id = obra.formato?.id;
    if (id == null) return undefined;
    const g = OBRAS_GENEROS.find((x) => x.formato === id);
    return {
        label: g?.label ?? obra.formato?.nome ?? '—',
        color: g?.color ?? '#94a3b8',
    };
}

interface SearchResultGridProps {
    results: Obra[];
    loading: boolean;
    /** Quando verdadeiro (filtro «Todos»), mostra o formato no topo de cada capa. */
    showFormatoOnCover?: boolean;
}

export const SearchResultGrid: React.FC<SearchResultGridProps> = ({ results, loading, showFormatoOnCover }) => {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center py-28 text-white/40">
                <Loader2 className="mb-4 size-10 animate-spin text-orange-500" />
                <p className="text-sm font-medium text-white/50">Carregando obras…</p>
            </div>
        );
    }

    if (results.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center space-y-4 py-28 text-center">
                <div className="flex size-20 items-center justify-center rounded-2xl border border-white/10 bg-white/[0.03] text-white/25">
                    <BookOpen size={36} strokeWidth={1.5} />
                </div>
                <div className="space-y-2">
                    <h3 className="text-lg font-bold text-white">Nenhuma obra encontrada</h3>
                    <p className="mx-auto max-w-sm text-sm text-white/45">Ajuste a pesquisa, o formato ou os filtros e tente de novo.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4 xl:grid-cols-5">
            {results.map((obra) => (
                <MinimalistWorkCard
                    key={obra.id}
                    obra={{
                        id: obra.id,
                        nome: obra.nome,
                        imagem: obra.imagem,
                        favoritada: obra.favoritada,
                        total_capitulos: obra.total_capitulos ?? obra.capitulos_count,
                    }}
                    formatoBadge={showFormatoOnCover ? formatoBadgeFromObra(obra) : undefined}
                />
            ))}
        </div>
    );
};
